/* eslint-disable import/no-unresolved */
import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';
import { SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

import Container from '../../../Core/Container';
import Link from '../../../Core/Link';
import RichText, { fragment } from '../../../Core/RichText';
import IndividualBlade from '../../IndividualBlades';
import Carousel from '../../../Core/Carousel';

import {
  Heading,
  CarouselImageWrapper,
  Footer,
  Wrapper,
  StyledImage,
} from './styles';

const CarouselGallery = ({ data }) => {
  if (!data) return null;
  const {
    backgroundColor,
    sectionContainerHeading,
    sectionContainerHeadingColor,
    contentAlignment,
    elements,
    ctas,
  } = data;

  const galleryImages = elements.find(
    el => el.component === 'gallery-carousel',
  );

  const breakpoints = {
    320: {
      slidesPerView: '1',
      spaceBetween: 24,
    },
    768: {
      slidesPerView: '4',
      spaceBetween: 24,
    },
  };

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Heading
          headingColor={sectionContainerHeadingColor}
          contentAlignment={contentAlignment}
        >
          {children}
        </Heading>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <Heading
          headingColor={sectionContainerHeadingColor}
          contentAlignment={contentAlignment}
        >
          {children}
        </Heading>
      ),
    },
  };

  return (
    <Container backgroundColor={backgroundColor}>
      <Wrapper>
        {sectionContainerHeading && (
          <RichText document={sectionContainerHeading} options={header} />
        )}
        <Carousel
          breakpoints={breakpoints}
          className="far-out-button"
          modules={[Pagination]}
          pagination={{ clickable: true }}
        >
          {galleryImages.imagesDam.map(image => {
            return (
              <SwiperSlide>
                <CarouselImageWrapper key={image.id}>
                  <StyledImage src={image} alt={image.altText || ''} />
                </CarouselImageWrapper>
              </SwiperSlide>
            );
          })}
        </Carousel>
        {ctas && (
          <Footer>
            {ctas &&
              ctas.map(cta => {
                if (cta.hideFrench === true) return null;
                return cta.internal.type === 'ContentfulBlade' ? (
                  <IndividualBlade key={cta.id} data={cta} />
                ) : (
                  <Link key={cta.id} data={cta}>
                    <RichText document={cta.label} options={fragment} />
                  </Link>
                );
              })}
          </Footer>
        )}
      </Wrapper>
    </Container>
  );
};

CarouselGallery.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default CarouselGallery;
